import { render, staticRenderFns } from "./allianzAssociation.vue?vue&type=template&id=e27fd95e&scoped=true"
import script from "./allianzAssociation.vue?vue&type=script&lang=js"
export * from "./allianzAssociation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27fd95e",
  null
  
)

export default component.exports